import { LoadingContext } from "context/LoadingContext";
import { useContext, useEffect } from "react";
import { useMutation } from "react-query";
import { http } from "shared/util/http";

export interface DeleteOptions<Trequest = any, Tresponse = any, TContext = any> {
  url: string;
  onMutate?: (request: Trequest) => void;
  onSuccess?: (response: Trequest, request: Tresponse, context?: TContext) => void;
  onError?: (data: any) => void;
  onFinaly?: () => void;
}

function useDelete<T>(options: DeleteOptions) {
  const { reservarCarregamento } = useContext(LoadingContext);

  const mutacao = useMutation({
    mutationFn: async (id) => {
      await http.delete<T>(`${options.url}/${id}`);
    },
    onMutate: (request) => {
      if (options.onMutate) {
        options.onMutate(request);
      }
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
    onSettled: () => {
      if (options.onFinaly) {
        options.onFinaly();
      }
    },
  });

  // Mesma armadilha do useFetch: no react-query v3 o `onSettled` é callback do observer e
  // não roda se o componente desmontar durante a requisição — o overlay global ficava
  // ligado cobrindo o sistema inteiro. A liberação agora é cleanup de efeito.
  useEffect(() => {
    if (!mutacao.isLoading) return;
    return reservarCarregamento();
  }, [mutacao.isLoading, reservarCarregamento]);

  return mutacao;
}

export default useDelete;
